import { cva } from '@bedrock/ui/utils';

export const ctaBlockVariants = cva(
  'patterns-cta-block flex w-full sm:w-auto flex-col gap-xs flex-wrap sm:gap-sm sm:flex-row',
  {
    variants: {
      horizontalPosition: {
        center: 'justify-center items-center',
        left: 'justify-start items-start',
        right: 'justify-end items-end',
      },
    },
    defaultVariants: {
      horizontalPosition: 'left',
    },
  },
);

export const ctaItemVariants = cva(
  'patterns-cta-block-item br-type-button-sm sm:br-type-button-lg br-button-size-sm sm:br-button-size-lg w-full md:w-auto',
  {
    variants: {
      horizontalPosition: {
        center: 'w-full sm:w-auto',
        left: '',
        right: '',
      },
    },
    defaultVariants: {
      horizontalPosition: 'left',
    },
  },
);
